module.exports = __webpack_public_path__ + "static/media/background-playlist-image-1.f7ca01af.svg";